// import axios from "axios";

// const OneClickClient = axios.create({
//   baseURL: "https://chat.circlechess.com" ,
//   withCredentials: true,
//   headers: {
//     "api-key": "3c311b2d-f168-47c2-9d2a-de5c2df8677a",
//     'Content-Type':'application/json'

//   },
// });

// export default OneClickClient;

import Environment from '../../environment';
import axios from 'axios';
import {onFulfilled} from './interceptors/request';
import {handleLogout} from '@/Utils/CommonUtils';
// import {useNavigation} from '@react-navigation/native';
import {ScreenName} from '@/navigators/StackConstants';

const useOneClickClient = () => {
//   const navigation = useNavigation<any>();

  const OneClickClient = axios.create({
    baseURL: Environment.CHAT_API_URL,
  });

  OneClickClient.interceptors.request.use(onFulfilled);

  OneClickClient.interceptors.response.use(
    response => {
      // If the request was made and the server responded with a status code
      // that falls out of the range of 2xx, this function will not be called.
      return response;
    },
    error => {
      // If request was sent and server responded with a status outside of the 2xx range
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // Handle 401 error code.
            handleLogout(() => {
            //   navigation?.navigate(ScreenName?.Login);
            });
            console.error('401 Unauthorized Error');
            break;
          case 403:
            // Handle 403 error code.
            handleLogout(() => {
            //   navigation?.navigate(ScreenName?.Login);
            });
            console.error('403 Forbidden Error');
            break;
          default:
            break;
        }
      }
      return Promise.reject(error.response.data);
    },
  );
  return OneClickClient;
};
export default useOneClickClient;
